import { Fragment, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import "./NcertTestScreen.css";

import { fetchChapterData } from "../../../../redux/chapter/chapterSlice";

import Heading from "./components/Heading/Heading";

import ProgressBar from "./components/ProgressBar/ProgressBar";

import Chapter from "./components/Chapter/Chapter";

import { useHistory, useLocation } from "react-router-dom";

import Modal from "../../../../shared/components/Modal/Modal";
import Button from "../../../../shared/components/Button/Button";
import images from "../../../../utilities/images/images";

const NcertTestScreen = () => {
  const dispatch = useDispatch();

  const navigate = useHistory();

  const location = useLocation();

  const [darkMode, setDarkMode] = useState(false);

  const [showHeader, setShowHeader] = useState(true);
  const [showExitModal, setShowExitModal] = useState(false);

  const chapter_id = location?.state?.chapter_id;

  const action = location?.state?.action;

  const { chapter_info, user_progress, loading } =
    useSelector((state) => state.chapter) || {};

  const read_mode_params = action === "read_mode" ? "1" : "0";

  useEffect(() => {
    if (chapter_id) {
      dispatch(fetchChapterData({ chapter_id }));
    }
  }, [dispatch, chapter_id]);

  const total = chapter_info?.total_qn_blanks || 0;

  const handleExitTest = () => {
    setShowExitModal(false);
    navigate.push("/ncert");
  };

  if (loading) return <div className="spinner" />;

  return (
    <Fragment>
      <div
        className={`sticky-header-container ${darkMode ? "dark" : "light"} ${
          !showHeader || showExitModal ? "hidden" : ""
        }`}
      >
        {showHeader && (
          <>
            <Heading
              title={chapter_info?.chapter_name}
              onBack={() => setShowExitModal(true)}
              darkMode={darkMode}
              setDarkMode={setDarkMode}
            />

            {read_mode_params !== "1" && (
              <ProgressBar
                total={total}
                userProgress={user_progress}
                label="Progress"
                darkMode={darkMode}
              />
            )}
          </>
        )}
      </div>

      <div className="chapter-section container-lg container-fluid">
        <Chapter
          darkMode={darkMode}
          onPracticeCompleted={() => setShowHeader(false)}
        />
      </div>

      <Modal
        isOpen={showExitModal}
        onClose={() => setShowExitModal(false)}
        width="28rem"
        height="17rem"
        closeButtonTop="25%"
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "1.25rem 1.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "rgba(0, 0, 0, 0.08)",
              width: "2.5rem",
              height: "2.5rem",
              borderRadius: "999px",
              margin: "0 auto 0.75rem",
            }}
          >
            <img
              src={images.exit_modal_icon}
              alt="exit"
              style={{ width: "1.1rem", height: "1.1rem" }}
            />
          </div>

          <h2
            style={{
              margin: 0,
              textAlign: "center",
              fontSize: "1.35rem",
              fontWeight: 500,
              color: "#181d27",
            }}
          >
            Exit Test
          </h2>

          <p
            style={{
              margin: "0.6rem 0 1.5rem",
              textAlign: "center",
              fontSize: "0.95rem",
              lineHeight: "1.35rem",
              color: "#535862",
            }}
          >
            Are you sure you want to exit? Your answers are saved and you can
            resume anytime.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1.25rem",
            }}
          >
            <Button
              title="Go Back To Test"
              variant="outlined"
              color="error"
              onClick={() => setShowExitModal(false)}
            />
            <Button
              title="Exit Test"
              variant="contained"
              color="error"
              onClick={handleExitTest}
            />
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default NcertTestScreen;
